const CryptoJS = require('crypto-js')

export const codeB64 = {
  decode: (data) => {
    return CryptoJS.enc.Base64.parse(data).toString(CryptoJS.enc.Utf8)
  },
  encode: (text) => {
    return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(text))
  }
}



